import { render, staticRenderFns } from "./TrainingPlanItemNotes.vue?vue&type=template&id=7b6f0376&scoped=true&"
import script from "./TrainingPlanItemNotes.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemNotes.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemNotes.vue?vue&type=style&index=0&id=7b6f0376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f0376",
  null
  
)

export default component.exports